import React, { Component } from 'react';
import DashboardView from '../components/views/DashboardView';
import DataGrid from '../components/DataGrid';
import TemplatesData from './TemplatesData';
import { nanoid } from 'nanoid';
import Responsive from '../components/Responsive';
import CustomLoader from '../components/CustomLoader';
import { translate } from '../utils/useful';

class TemplatesView extends Component {
    state = {
        data: [
            { id: nanoid(), title: 'Manufacturing Inspection System [AI]', img: '/assets/icons/templates/template1.jpeg' },
            { id: nanoid(), title: 'Products Info in Live Commerce [AI]', img: '/assets/icons/templates/template2.jpeg' },
            { id: nanoid(), title: 'Agile project management', img: '/assets/icons/templates/template3.jpeg' }
        ]
    }
    render() {
        return (
            <div className="h-100  w-100  scroll-no-scrollbar" style={{ background: '#f8f9fa' }}>
                <div className="row m-0 p-0">
                    <div className="col-12 py-4 ">
                        <div>
                            <div className="d-flex flex-wrap">
                                {this.props.data?.map((prop, index) => {
                                    let Component = TemplatesData
                                    if (Component) {
                                        return (
                                            <Responsive className={'d-flex prd-5 '} key={index} width={this.props.width} media={{ xs: "12", sm: '6', md: '4', lg: "3", xl: "2" }}>
                                                <div className={(this.props.marginBottom ?? 'w-100 px-2 mb-4')} >
                                                    <Component data={prop} schema={this.props.schema} onClick={this.props.onClick} dontShowPrice={this.props.dontShowPrice} background={this.props.background} changePage={this.props.changePage} functionsHandler={this.props.functionsHandler} settings={this.props.settings} changePreview={this.props.changePreview} index={index} previewNum={this.props.previewNum} previewData={this.props.previewData} />
                                                </div>
                                            </Responsive>
                                        )
                                    }
                                })}
                            </div>

                            {(this.props.data?.length === 0 && !this.props.isLoading) && (
                                <div className="w-100 text-center ">
                                    {this.props.data?.length === 0 && !this.props.isLoading && (
                                        <p style={{ fontSize: 16, color: '#789', marginTop: 20 }}>{translate('found-nothing')}</p>
                                    )}
                                </div>
                            )}

                            {(this.props.isLoading && !this.props.hideLoader) && (
                                <div className="mt-2 d-flex justify-content-center">
                                    <CustomLoader isLoading={true} />
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TemplatesView;